export const BAGS = [
    { id: "page-turner", label: "The Page Turner", emoji: "📖" },
    { id: "plot-twist", label: "The Plot Twist", emoji: "✨" },
    { id: "whole-story", label: "The Whole Story", emoji: "🎨" },
    { id: "book-and-brew", label: "The Book & Brew", emoji: "☕" },
];

export const bagById = (id) => BAGS.find((b) => b.id === id);
